import axios from "axios";

export interface ISaveContactDetailsOnFullAppFormEvent {
  transaction: {
    id: string;
  };
  formData: {
    street: string;
    housenumber: string;
    postcode: string;
    city: string;
    country: string;
    prevstreet?: string;
    prevhousenumber?: string;
    prevpostcode?: string;
    prevcity?: string;
    prevcountry?: string;
    email: string;
    mobilePhoneCountryCode: string;
    mobilePhoneNumber: string;
    residentSince: string;
    isLivingInDeStartDate?: string;
    residencePermitStatus?: string;
    residencePermitEndDate?: string;
    workPermitStatus?: string;
    workPermitEndDate?: string;
    maritalStatus: string;
    isLivingTogether: boolean;
  };
}

export const saveContactDetailsFullAppForm = async (
  transactionId: string,
  formValues: {
    street: string;
    housenumber: string;
    postcode: string;
    city: string;
    country: string;
    prevstreet?: string;
    prevhousenumber?: string;
    prevpostcode?: string;
    prevcity?: string;
    prevcountry?: string;
    email: string;
    mobilePhoneCountryCode: string;
    mobilePhoneNumber: string;
    residentSince: string;
    isLivingInDeStartDate?: string;
    residencePermitStatus?: string;
    residencePermitEndDate?: string;
    workPermitStatus?: string;
    workPermitEndDate?: string;
    maritalStatus: string;
    livingStatus: string;
  }
) => {
  const body: ISaveContactDetailsOnFullAppFormEvent = {
    transaction: {
      id: transactionId,
    },
    formData: {
      street: formValues.street,
      housenumber: formValues.housenumber,
      postcode: formValues.postcode,
      city: formValues.city,
      country: formValues.country,
      prevstreet: formValues.prevstreet,
      prevhousenumber: formValues.prevhousenumber,
      prevpostcode: formValues.prevpostcode,
      prevcity: formValues.prevcity,
      prevcountry: formValues.prevcountry,
      email: formValues.email,
      mobilePhoneCountryCode: formValues.mobilePhoneCountryCode,
      mobilePhoneNumber: formValues.mobilePhoneNumber,
      residentSince: formValues.residentSince,
      isLivingInDeStartDate: formValues.isLivingInDeStartDate,
      residencePermitStatus: formValues.residencePermitStatus,
      residencePermitEndDate: formValues.residencePermitEndDate,
      workPermitStatus: formValues.workPermitStatus,
      workPermitEndDate: formValues.workPermitEndDate,
      maritalStatus: formValues.maritalStatus,
      isLivingTogether: formValues.livingStatus === "yes",
    },
  };

  return axios.post(
    process.env.REACT_APP_SAVE_CONTACT_DETAILS_FULL_APP_FORM_URL,
    body
  );
};
